import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Leadingcabserviceacrossindia() {



  const cardData =
  {
    keyword: 'Leading Cab Services across India',
    heading: 'Aaryan Travels: Leading Cab Services across India',
    headingDescription: ' Aaryan Travels stands among the Leading Cab Services across India, offering reliable and professional transportation solutions in major cities such as Pune, Mumbai, Delhi, Bangalore, Hyderabad, Chennai, Kolkata, and Ahmedabad. Whether it’s airport transfers, corporate mobility, wedding transportation, local city rides, or long-distance outstation trips, our fleet of sedans, SUVs, luxury cars, and tempo travellers ensures comfort and safety throughout the journey. With trained chauffeurs, 24/7 availability, and transparent pricing, we serve individuals, families, tourists, and corporate clients nationwide. From metro cities to industrial hubs, Aaryan Travels continues to set standards as a trusted name in pan-India cab services.',

    top: 'Top Places to Visit in India with Aaryan Travels',

 "topPlaces": [
  {
    "title": "Taj Mahal, Agra",
    "description": "The Taj Mahal, one of the Seven Wonders of the World, was built by Emperor Shah Jahan in memory of his wife Mumtaz Mahal. Made from white marble with intricate carvings, it changes color with the daylight. The reflecting pool and symmetrical gardens enhance its beauty. Millions visit annually to witness its timeless charm. The Taj Mahal is India’s eternal monument of love."
  },
  {
    "title": "Golden Temple, Amritsar",
    "description": "The Golden Temple, also known as Harmandir Sahib, is the holiest shrine of Sikhism. Its gold-plated structure reflects beautifully in the surrounding Amrit Sarovar. Devotees and visitors from across the world experience peace through Gurbani hymns. The temple’s Langar serves free meals to thousands daily. The Golden Temple is India’s shining emblem of unity and devotion."
  },
  {
    "title": "Jaipur City Palace, Rajasthan",
    "description": "City Palace in Jaipur is a royal complex combining Rajput and Mughal architecture. Visitors admire its grand courtyards, museums, and the intricately designed Peacock Gate. Part of the palace still houses the royal family. Traditional textiles, weaponry, and paintings showcase regal heritage. City Palace is India’s proud symbol of royal legacy."
  },
  {
    "title": "Varanasi Ghats, Uttar Pradesh",
    "description": "Varanasi, one of the world’s oldest cities, is lined with sacred ghats along the Ganga River. Pilgrims perform rituals, meditation, and holy dips at sunrise. The evening Ganga Aarti with lamps and chants creates a divine experience. Narrow lanes filled with temples add to its charm. Varanasi is India’s living spiritual capital."
  },
  {
    "title": "Kerala Backwaters, Alleppey",
    "description": "The Kerala Backwaters offer serene houseboat cruises through interconnected lagoons and canals. Surrounded by coconut groves and paddy fields, it provides a peaceful escape into nature. Traditional meals are served onboard while floating gently. Sunset views over still waters are breathtaking. The backwaters are India’s floating paradise."
  },
  {
    "title": "Rann of Kutch, Gujarat",
    "description": "The Great Rann of Kutch is a vast salt desert that glows silver under moonlight. The annual Rann Utsav features folk music, dance, and luxury tent stays. Camel rides and handicraft shopping make it a cultural delight. The sunrise and sunset views are magical. The Rann is India’s surreal white wonderland."
  },
  {
    "title": "Mysore Palace, Karnataka",
    "description": "Mysore Palace is an opulent royal residence with stained glass windows, domes, and ornate halls. Every Sunday and during Dasara, it is illuminated with nearly 100,000 bulbs. The interiors showcase royal thrones, artwork, and grand architecture. It is one of the most visited palaces in India. Mysore Palace is India’s glowing marvel of royalty."
  },
  {
    "title": "Gateway of India, Mumbai",
    "description": "The Gateway of India is a monumental arch built facing the Arabian Sea. It marked the ceremonial entrance during British rule. Tourists gather for sea breeze, street snacks, and ferry rides to Elephanta Caves. Its impressive structure reflects Indo-Saracenic architecture. The Gateway of India is Mumbai’s coastal landmark of grandeur."
  },
  {
    "title": "Ajanta & Ellora Caves, Maharashtra",
    "description": "Ajanta and Ellora Caves are ancient rock-cut monuments featuring Buddhist, Hindu, and Jain sculptures. Ajanta is known for its stunning fresco paintings, while Ellora’s Kailasa Temple is carved from a single rock. These UNESCO World Heritage Sites showcase extraordinary craftsmanship. The caves are India’s historic gallery of art and devotion."
  },
  {
    "title": "Andaman & Nicobar Islands",
    "description": "The Andaman Islands offer crystal-clear waters, coral reefs, and pristine beaches like Radhanagar. Activities like snorkeling and scuba diving reveal vibrant marine life. The historic Cellular Jail tells stories of India’s freedom struggle. Dense forests and boat rides add adventure. Andaman is India’s tropical escape to tranquility."
  }
],


"services": [
  {
    "name": "Leading Cab Services across India",
    "description": "Our Leading Cab Services across India offer comprehensive transportation solutions spanning major cities and towns, ensuring reliable, safe, and comfortable travel for all your needs. With a vast fleet of vehicles, professional drivers, and advanced booking systems, we provide seamless mobility for corporate clients, tourists, and daily commuters alike. Whether you require local rides, outstation trips, or airport transfers, our nationwide presence ensures top-tier service wherever you go."
  },
  {
    "name": "Nationwide Top Taxi Providers",
    "description": "Nationwide Top Taxi Providers is a network of trusted taxi companies across India, delivering exceptional service quality, punctuality, and safety standards. Our partners are selected based on their reliability, fleet condition, and driver professionalism, ensuring consistent and convenient taxi services in every region. From metropolitan hubs to smaller cities, you can count on us for hassle-free rides tailored to your requirements."
  },
  {
    "name": "India’s Best Cab Services",
    "description": "India’s Best Cab Services stand out by combining affordability, quality, and extensive coverage. Our services cater to both individual travelers and businesses, offering well-maintained vehicles, experienced drivers, and a smooth booking process through multiple platforms. We prioritize customer satisfaction by delivering timely pickups, clean vehicles, and courteous service across all Indian cities."
  },
  {
    "name": "Leading Car Hire Networks India",
    "description": "Leading Car Hire Networks India connect travelers with the largest and most trusted rental car companies in the country. Whether you need a self-drive option or a chauffeur-driven vehicle, our network offers a wide variety of cars including sedans, SUVs, luxury vehicles, and budget-friendly options. Our streamlined booking process ensures availability and competitive pricing across multiple locations."
  },
  {
    "name": "Premier Cab Services India",
    "description": "Premier Cab Services India focuses on delivering luxury and executive transportation options to discerning clients nationwide. We offer premium vehicles equipped with modern amenities, professional chauffeurs, and customized travel plans. Ideal for corporate executives, VIP clients, and special occasions, our service ensures a refined and comfortable travel experience anywhere in India."
  },
  {
    "name": "Top Transport Services India",
    "description": "Top Transport Services India provides comprehensive logistics and passenger transport solutions to businesses and individuals. From corporate shuttles to intercity travel, our services are designed for efficiency, safety, and reliability. We maintain a large fleet of vehicles with GPS tracking and provide flexible booking options to suit diverse transportation needs."
  },
  {
    "name": "Top Rated Cab Firms India",
    "description": "Top Rated Cab Firms India are recognized for their excellent customer feedback, timely service, and well-maintained vehicles. These companies set the benchmark in urban and intercity transportation, delivering hassle-free cab experiences with professional drivers and transparent pricing. Their strong commitment to safety and quality makes them favorites among regular commuters and corporate clients alike."
  },
  {
    "name": "Trusted Cab Operators India",
    "description": "Trusted Cab Operators India include vetted and experienced service providers who prioritize passenger safety and satisfaction. We collaborate with operators who maintain high standards in vehicle condition, driver training, and customer service. Whether for daily commutes or long-distance travel, you can trust these operators to deliver dependable and courteous cab services throughout India."
  },
  {
    "name": "National Cab Companies India",
    "description": "National Cab Companies India operate extensive fleets across multiple states, ensuring nationwide coverage for all your transportation needs. Their large-scale operations provide easy access to cabs for urban and rural areas alike, backed by strong customer support and standardized service protocols. Ideal for businesses requiring consistent transport solutions across locations."
  },
  {
    "name": "Leading Taxi Brands India",
    "description": "Leading Taxi Brands India represent the most recognized and customer-friendly taxi services in the country. These brands are synonymous with quality, affordability, and innovation, offering app-based bookings, cashless payments, and real-time ride tracking. Their presence in major cities ensures convenient and reliable transportation at competitive rates."
  },
  {
    "name": "Elite Car Hire India",
    "description": "Elite Car Hire India offers luxury vehicle rentals for corporate events, weddings, and personal travel. Featuring high-end sedans, SUVs, and chauffeur services, we provide an exclusive experience marked by comfort, style, and professionalism. Our elite fleet is meticulously maintained and available across key Indian cities."
  },
  {
    "name": "Largest Cab Networks India",
    "description": "Largest Cab Networks India encompass thousands of vehicles and drivers, creating one of the most extensive transportation infrastructures in the country. This vast network ensures availability and rapid response times in metropolitan areas as well as remote regions, supporting diverse travel requirements from daily commutes to long-haul journeys."
  },
  {
    "name": "India Leading Cab Operators",
    "description": "India Leading Cab Operators are industry pioneers known for innovation, customer-centric policies, and robust service delivery. They invest in technology, driver training, and fleet management to provide superior cab experiences. Their leadership in market share and quality standards sets them apart as trusted names in Indian transportation."
  },
  {
    "name": "Best Cab Services India",
    "description": "Best Cab Services India deliver top-notch transportation options combining safety, convenience, and affordability. They cater to individual and corporate clients with services ranging from daily city rides to outstation tours. Their commitment to maintaining clean vehicles, professional drivers, and prompt service ensures customer loyalty and high satisfaction."
  },
  {
    "name": "Premium Cab Networks India",
    "description": "Premium Cab Networks India specialize in high-quality transportation solutions with an emphasis on luxury and reliability. Offering premium sedans, SUVs, and executive services, they serve corporate travelers and VIP clients who demand excellence. Their network covers major urban centers and provides customized travel packages tailored to client needs."
  }
],
"tableData": [
  ["Leading Cab Services across India", "Nationwide Top Taxi Providers"],
  ["India’s Best Cab Services", "Leading Car Hire Networks India"],
  ["Premier Cab Services India", "Top Transport Services India"],
  ["Top Rated Cab Firms India", "Trusted Cab Operators India"],
  ["National Cab Companies India", "Leading Taxi Brands India"],
  ["Elite Car Hire India", "Largest Cab Networks India"],
  ["India Leading Cab Operators", "Best Cab Services India"],
  ["Premium Cab Networks India", "—"]
],

"whychoose": [
  {
    "WhyChooseheading": "Leading Cab Services Across India",
    "WhyChoosedescription": "Aaryan Travels is a top-rated cab service provider with an extensive network covering major cities and towns across India."
  },
  {
    "WhyChooseheading": "Pan-India Coverage for Seamless Travel",
    "WhyChoosedescription": "Whether local or outstation, our services span across all key destinations in India to meet your travel needs."
  },
  {
    "WhyChooseheading": "Wide Range of Well-Maintained Vehicles",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and tempo travellers suited for all group sizes and comfort preferences."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Our drivers are courteous, licensed, and familiar with routes nationwide to ensure safe and timely journeys."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
    "WhyChoosedescription": "Enjoy upfront pricing inclusive of fuel, tolls, and driver allowances for a hassle-free travel experience."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Smooth Bookings",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with all your booking needs and queries."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for Every Travel Requirement",
    "WhyChoosedescription": "Choose from hourly rentals, point-to-point trips, or long-distance journeys tailored to your schedule."
  },
  {
    "WhyChooseheading": "Commitment to Safety and Customer Satisfaction",
    "WhyChoosedescription": "We prioritize your safety and comfort with sanitized vehicles and professional service at every step."
  }
]































  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer leading cab services across India?',
    answer: 'Yes, Aaryan Travels provides top-notch cab services across major cities and towns throughout India, ensuring quality and reliability.',
  },
  {
    question: 'How can I book cab services across India with Aaryan Travels?',
    answer: 'You can easily book cabs through our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'What types of vehicles are available for cab services across India?',
    answer: 'We offer a wide range of vehicles including hatchbacks, sedans, SUVs, and luxury cars suitable for all travel needs.',
  },
  {
    question: 'Are your drivers experienced and familiar with routes across India?',
    answer: 'Absolutely. Our drivers are professional, licensed, and knowledgeable about various routes across India to ensure safe and timely travel.',
  },
  {
    question: 'Can I book cabs for local as well as outstation trips across India?',
    answer: 'Yes, Aaryan Travels offers cab services for both local travel and outstation trips across India.',
  },
  {
    question: 'Are safety and hygiene protocols followed for cab services across India?',
    answer: 'All vehicles are regularly sanitized, and drivers follow strict safety measures to protect passengers during their journey.',
  },
  {
    question: 'Is cab service available 24x7 across India?',
    answer: 'Yes, Aaryan Travels provides 24x7 cab booking and services across India for your convenience.',
  },
  {
    question: 'What payment options are accepted for cab services across India?',
    answer: 'We accept cash, digital wallets, UPI, and card payments for smooth and secure transactions.',
  },
  {
    question: 'Can I customize pickup and drop-off locations anywhere across India?',
    answer: 'Yes, you can specify your preferred pickup and drop-off points as per your travel plans anywhere in India.',
  },
  {
    question: 'Does Aaryan Travels provide customer support during the trip?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vikram Singh',
    feedback: 'Aaryan Travels offers exceptional cab services across India. Their drivers are professional, and the booking process is hassle-free.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Meera Joshi',
    feedback: 'Reliable and comfortable cab services from Aaryan Travels for both local and outstation trips anywhere in India.',
    rating: 5,
  },
];



















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Leading Cab Services across India",
  "description": "Aaryan Travels offers leading cab services across India with nationwide top taxi providers, trusted operators, and premium cab networks for all your travel needs.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "Country",
    "name": "India"
  },
  "serviceType": "Cab Services",
  "keywords": "Leading Cab Services across India, Nationwide Top Taxi Providers, India’s Best Cab Services, Leading Car Hire Networks India, Premier Cab Services India, Top Transport Services India, Top Rated Cab Firms India, Trusted Cab Operators India, National Cab Companies India, Leading Taxi Brands India, Elite Car Hire India, Largest Cab Networks India, India Leading Cab Operators, Best Cab Services India, Premium Cab Networks India"
};






  return (
    <div>

<Helmet>
  <title>Leading Cab Services across India | Nationwide Taxi Providers | Aaryan Travels</title>
  <meta
    name="description"
    content="Discover leading cab services across India with Aaryan Travels. Trusted nationwide taxi providers, premium cab networks, and top-rated operators for seamless travel."
  />
  <meta
    name="keywords"
    content="Leading Cab Services across India, Nationwide Top Taxi Providers, India’s Best Cab Services, Leading Car Hire Networks India, Premier Cab Services India, Top Transport Services India, Top Rated Cab Firms India, Trusted Cab Operators India, National Cab Companies India, Leading Taxi Brands India, Elite Car Hire India, Largest Cab Networks India, India Leading Cab Operators, Best Cab Services India, Premium Cab Networks India"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/46.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Leadingcabserviceacrossindia;